export enum ProjectStatus {
    Trial = "Trial",
    Active = "Active",
    Cancelled = "Cancelled",
    InArrears = "InArrears"
}